import { createContext } from 'react';

/**
 * "Is there an app-level {@link TooltipProvider} above me?"
 *
 * Radix keeps its skip-delay state (`isOpenDelayed`) on the PROVIDER, so the
 * "second tooltip opens instantly" behaviour only works across triggers that
 * share ONE provider. A `Tooltip` that mounts its own provider is an island:
 * moving from it to the next trigger always re-waits the full delay.
 *
 * So `Tooltip` renders its own provider ONLY when this is `false` — which
 * keeps standalone call sites (Storybook stories, jest tests, any tree that
 * forgot the root provider) working, since Radix THROWS when `Tooltip.Root`
 * has no provider above it.
 */
export const HasTooltipProviderContext = createContext(false);
